import cn from 'classnames';
import { Tag, TimeFilledIcon, PlayCircleFilledIcon } from 'ui';
import { useShowInProgressStatus } from './hooks';
import { TodoWidgetItemTimeText } from './TodoWidgetItemTimeText';

type P = {
  startTime: Date;
  endTime: Date;
  hasInProgressStatus: boolean;
};

const TodoWidgetItemTimeTag = ({ startTime, endTime, hasInProgressStatus }: P) => {
  const showInProgressStatus = useShowInProgressStatus({ startTime, endTime, hasInProgressStatus });

  return (
    <Tag
      className={cn('todo-widget-time-tag', {
        'todo-widget-time-tag--in-progress': showInProgressStatus,
      })}
      icon={
        showInProgressStatus ? (
          <PlayCircleFilledIcon className="todo-widget-time-tag__icon--in-progress" />
        ) : (
          <TimeFilledIcon />
        )
      }
    >
      <TodoWidgetItemTimeText endTime={endTime} showInProgressStatus={showInProgressStatus} />
    </Tag>
  );
};

export default TodoWidgetItemTimeTag;
